import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const NavLinksContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const LinksWrapper = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  height: 100%;
  list-style: none;
`;

const LinkItem = styled.li`
  height: 100%;
  padding: 0 1.1em;
  color: #222;
  font-weight: 500;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  display: flex;

  .active {
    border-bottom: 3px solid #559ed6;
  }
`;

const Link = styled(NavLink)`
  text-decoration: none;
  color: inherit;
  font-size: inherit;
  height: 100%;
  display: flex;
  align-items: center;
  border-bottom: 3px solid transparent;
  transition: all 220ms ease-in-out;

  :hover {
    border-bottom: 3px solid #559ed6;
  }
`;

export function NavLinks() {

  const { t } = useTranslation();

  return (
    <NavLinksContainer>
      <LinksWrapper>
        <LinkItem>
          <Link
            className={({ isActive }) => (isActive ? "active" : "")}
            end
            to="/demo"
          >
            {t("demoPage")}
          </Link>
        </LinkItem>
        <LinkItem>
          <Link
            className={({ isActive }) => (isActive ? "active" : "")}
            end
            to="/account"
          >
            {t("personPage")}
          </Link>
        </LinkItem>
        <LinkItem>
          <Link
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/panel"
          >
            {t("controlPanel")}
          </Link>
        </LinkItem>
        <LinkItem>
          <Link
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/storybook"
          >
            Storybook
          </Link>
        </LinkItem>
      </LinksWrapper>
    </NavLinksContainer>
  );
}
